import React from 'react';
import PropTypes from 'prop-types';

const IndicatorField = ({ color = '#b5bdc5' }) => (
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <path
                d="M3,6 C2.44771525,6 2,6.44771525 2,7 L2,11 C2,11.5522847 2.44771525,12 3,12 L15,12 C15.5522847,12 16,11.5522847 16,11 L16,7 C16,6.44771525 15.5522847,6 15,6 L3,6 Z M3,4 L15,4 C16.6568542,4 18,5.34314575 18,7 L18,11 C18,12.6568542 16.6568542,14 15,14 L3,14 C1.34314575,14 2.02906125e-16,12.6568542 0,11 L4.4408921e-16,7 C2.41183085e-16,5.34314575 1.34314575,4 3,4 Z"
                id="indicatorfield-path-1"
            />
        </defs>
        <g
            id="Svg-Icons/18px-(All-icons)/field_standard"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <mask id="mask-2" fill="white">
                <use xlinkHref="#indicatorfield-path-1" />
            </mask>
            <use id="Rectangle" fill={color} xlinkHref="#indicatorfield-path-1" />
        </g>
    </svg>
);

IndicatorField.propTypes = {
    color: PropTypes.string,
};

export default IndicatorField;
